/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ParamedicAccess from './paramedic-access';
import ParamedicAccessDetail from './paramedic-access-detail';
import ParamedicAccessUpdate from './paramedic-access-update';
import ParamedicAccessDeleteDialog from './paramedic-access-delete-dialog';

const ParamedicAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ParamedicAccess />} />
    <Route path="new" element={<ParamedicAccessUpdate />} />
    <Route path=":id">
      <Route index element={<ParamedicAccessDetail />} />
      <Route path="edit" element={<ParamedicAccessUpdate />} />
      <Route path="delete" element={<ParamedicAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ParamedicAccessRoutes;
